
import XLSX from 'xlsx';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { recruitingTemplate } from '../lib/upload-file';
import { recruitingTemplate, deliveryTemplate, recruiting_header, delivery_header, headersToCheck } from '../lib/upload-file';

@Component
export default class MissionDetail extends Vue {
  // @ts-ignore
  @Prop({ default: false }) visible: boolean;
  // @ts-ignore
  @Prop({ default: 0 }) type: number; // 1=招生列表,2=交付列表
  // @ts-ignore
  @Prop({ default: 0 }) is_check_header: true; // 1=招生列表,2=交付列表
  upload_file_list: any = [];
  file_list: any;
  @Watch('is_check_header')
  valueChange(newValue: string) {
    if (!newValue) {
      this.upload_file_list = [];
    }
  }

  beforeFileUpload(file: File) {
    if (this.upload_file_list.length == 1) return this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
    this.upload_file_list.push(file);
    this.readExcel(file);
    return false;
  }

  removeFile(file: any) {
    this.upload_file_list = [];
  }

  readExcel(file: any) {
    const fileReader = new FileReader();
    fileReader.onload = async (ev) => {
      const pre_data = ev.target;
      let data;
      if (pre_data) {
        data = pre_data.result;
      }
      const workbook = await XLSX.read(data, { type: 'binary' });
      const name = workbook.SheetNames[0]; //取第一张表
      const sheet_data = workbook.Sheets[name];
      if (this.type == 0) {
        return this.$emit('readExcel', sheet_data, headersToCheck);
      } else if (!headersToCheck(sheet_data, this.type == 1 ? recruiting_header : delivery_header)) {
        this.file_list = [];
        this.upload_file_list = [];
        return this.$message.error('文件表头错误');
      } else {
        this.file_list = sheet_data;
      }
    };
    fileReader.readAsBinaryString(file);
  }
  downloadTemplate() {
    if (this.type == 1) recruitingTemplate();
    else if (this.type == 2) deliveryTemplate();
    else this.$emit('downloadTemplate');
  }
  // 确认按钮
  handleOk() {
    if (this.file_list.length == 0) return this.$message.error('表格数据为空！');
    console.log(this.file_list);

    this.$emit('handleOk', this.file_list);
  }
  // 取消按钮;
  handleCancel() {
    this.$emit('handleCancel');
  }
}
